import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c(VCardTitle,[_vm._v(_vm._s(_vm.$t("heading.media")))]),_c(VCardText,[_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('form-group',{attrs:{"name":"main_media"},scopedSlots:_vm._u([{key:"default",fn:function({ attrs }){return [_c('multi-image-upload',_vm._b({attrs:{"maxSize":2,"imgsUrl":_vm.getPhotos()},on:{"fileSelected":function($event){return _vm.$emit('ImgSelected', $event)},"handle_delete_image":function($event){return _vm.$emit('ImgDeleted', $event)}}},'multi-image-upload',attrs,false))]}}])})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }